/*
 * Public API Surface of pepperi-lib/address
 */
export * from './address.module';
export * from './address.component';
